'use client';

import ProductCard from '@/components/products/ProductCard';
import { Grid, GridItem } from '@skin-seoul/design-system';
import { forwardRef } from 'react';
export const CollectionsProductGrid = forwardRef<HTMLDivElement, React.ComponentProps<typeof Grid>>((props, ref) => <Grid ref={ref} templateColumns={{
  base: 'repeat(2, minmax(0, 1fr))',
  tablet: 'repeat(2, minmax(0, 1fr))',
  desktop: 'repeat(3, minmax(0, 1fr))'
}} width="100%" gap={{
  base: 3,
  tablet: 4,
  desktop: 4
}} {...props} />);
export const CollectionsProductGridSkeleton = ({
  length = 12
}: {
  length?: number;
}) => {
  return <CollectionsProductGrid data-sentry-element="CollectionsProductGrid" data-sentry-component="CollectionsProductGridSkeleton" data-sentry-source-file="CollectionsProductGrid.tsx">
      {Array.from({
      length
    }).map((_, index) => <GridItem key={index} minWidth={0}>
          <ProductCard.Skeleton orientation="vertical" width="100%" />
        </GridItem>)}
    </CollectionsProductGrid>;
};
CollectionsProductGrid.displayName = 'CollectionsProductGrid';